import { render, staticRenderFns } from "./GalleryOrders.vue?vue&type=template&id=e082c2de&"
import script from "./GalleryOrders.vue?vue&type=script&lang=ts&"
export * from "./GalleryOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports